import * as React from "react";
import { Link } from "gatsby";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import { default as Old2005BlogPage, doNothingAnchor } from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—January 2008" />
	<Old2005BlogPage>
		<h2>January 2008</h2>



		<h3 className="blogdate">
		Wednesday, January 30, 2008
		</h3>






		<h4 className="blogitemtitle">
		Cigarette gold
		</h4>





			<div className="blogitembody">
			I saw an un-smoked cigarette on the ground and nearly picked it up.  I don't smoke, but many people do, and people are always asking for them from friends and strangers alike.  They're expensive to purchase - they're valuable.  Perhaps someone dropped this one and, later realizing it, felt a loss... like the loss of a dollar.<br /><br />I imagined if it was a dollar, then I would pick it up.  But imagine if cigarettes were acceptable for trade...  I think I'd charge 20 cigarettes for a copy of my CD, knowing that I could trade those for two meals.  I could get a good shish taouk for 12 cigarettes, or fish and chips for 6, or a burger and fries for 10.  Thick milkshakes are 5 or 6 cigarettes, depending upon the quality of the ice cream in them.  A cheap beer might be 3 or 4 cigarettes, and then a lot of people might smoke 3 or 4 cigarettes while drinking a cheap beer.<br /><br />The bank would have to reserve and store cigarettes and issue notes that were legally "backed" by cigarettes - that way we could pay rent and make major purchases without moving boxes of cartons of cigarettes.  A new Subaru WRX Wagon might cost 100,000 cigarettes (probably more)!  Eventually the banks would commence fractional reserve banking, and only a portion of our cigarettes would actually exist at the bank.  Perhaps the missing cigarettes would have been smoked by wealthy bank owners and aristocrats.<br /><br />Eventually the bank-issued notes would become legal tender (no longer backed by cigarettes) and commonly accepted for trade, instead of cigarettes.  Cigarettes would become rare and coveted, and the majority of the world's cigarettes would be in the hands of the wealthy.  People would be disgruntled, feeling tricked out of their wealth of cigarettes.  People would pass by banks and wonder where all the cigarettes in the world are truly residing.<br /><br />Cigarettes would still be traded on the global stock exchanges as a commodity.  Investors and brokers would trade bank-issued notes for bond documents that prove ownership of a specified amount of cigarettes.  When the market was good, people might sell their stock of cigarettes (for bank-issued notes).  Ultimately, nobody would actually see the cigarettes.<br /><br />Anyways... I wonder if anybody after me picked up that cigarette?
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 11:22 AM &nbsp;
			</div>






		<h3 className="blogdate">
		Monday, January 28, 2008
		</h3>






		<h4 className="blogitemtitle">
		Podcast: Welly Wonky
		</h4>





			<div className="blogitembody">
			This is a slide guitar instrumental that I wrote in late 2006 after arriving in Wellington, New Zealand.  It came out (of me, if one can say such a thing about a song) around the same time that I began writing <span style={{fontStyle: "italic"}}>Silent</span>.  The recording is from Access Radio - we were recording a radio show in August 2007.  It's a rough one-take, but it does the trick for my podcast!<br /><ul><li><span style={{textDecoration: "underline"}}></span><a href="/" onClick={doNothingAnchor}>(removed)</a><br /></li></ul>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 8:21 AM &nbsp;
			</div>






		<h3 className="blogdate">
		Friday, January 04, 2008
		</h3>






		<h4 className="blogitemtitle">
		Podcast: Down Again
		</h4>





			<div className="blogitembody">
			This song is proof that you can start a song idea and return to it years later - it remained strong in my mind for a long time.  I had started with the guitar rhythm and melody line, the first verse, and a chorus that I didn't care for.  One night, a couple months ago, I felt inclined to finish it; new verse, new choruses (or is it chori?), and overall cohesion.<br /><br />Imagine, if you will, some streets-of-Italy-style mandolin and accordion in this song (especially the instrumental break)...<br /><ul><li><a href="/" onClick={doNothingAnchor}>(removed)</a><br /></li></ul>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 1:00 PM &nbsp;
			</div>





		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
